import { HStack, Button, Icon } from "@chakra-ui/react";
import { colors } from "@/theme/colors";

// Shared segmented tab switcher — same button family as the global theme:
// 13px container radius, 9px tab radius, active tab solid teal + white.
export const SegmentedTabs = ({ tabs, value, onChange }) => (
  <HStack gap="1" bg={colors.white} border="1px solid" borderColor={colors.border}
    borderRadius="13px" p="1" display="inline-flex" w="fit-content">
    {tabs.map((t) => {
      const active = value === t.key;
      return (
        <Button key={t.key} size="sm" onClick={() => onChange(t.key)} data-testid={t.testId || `tab-${t.key}`}
          variant="ghost"
          borderRadius="9px"
          boxShadow="none"
          bg={active ? colors.teal : "transparent"}
          color={active ? "white" : colors.textSecondary}
          _hover={{ bg: active ? colors.tealHover : colors.tealTint }}>
          {t.icon && <Icon as={t.icon} boxSize="4" />}
          {t.label}
          {t.badge || null}
        </Button>
      );
    })}
  </HStack>
);
